import { DocumentService } from './../services/document.service';
import { OrderLineItemTypeEnum } from './../../shared/enums/order-lineitem-type.enum';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, Output, ViewChild ,EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Modal } from 'ngx-modal';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { CommonMessage } from '../common/common-messages';
import { Constants, IsoCodeThree, MemberType } from '../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, PurchaseFlow, cancelOrderOptions, BonusStatus } from '../common/enumerations';
import { AccountTypeConstants } from '../constants/account-type.constants';
import { PaymentMethodTypeConstants } from '../constants/payment-method-types.constants';
import { AccountType } from '../enums/echeck-accounttypes.enum';
import { MemberStatus } from '../enums/member-status.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MessageTypeEnum } from '../enums/message-type.enums';
import { NotificationType } from '../enums/notification-types.enum';
import { SecType } from '../enums/payment-ach-sectypes.enum';
import { AddressType, OrderStatus as OrderStatusEnums, PaymentMethodTypes, PaymentStatusId, ShippingType } from '../enums/order-source-type';
import { PaymentCardTypes } from '../enums/payment-card-types.enum';
import { Status } from '../enums/ticket-status.enum';
import { Priority, SourceType, SubtypesEnums, TicketType, Types } from '../enums/ticket-type.enum';
import { AddressInformation } from '../interface/address-detail-info';
import { AppCountryConfig } from '../interface/app-config';
import { BillingInformation } from '../interface/billing-info';
import { ParticipatingCountries } from '../interface/participating-countries.interface';
import { ProductInformation } from '../interface/product-info';
import { ShippingAddressInfoConfig } from '../interface/shipping-address-info-config.interface';
import { ShippingInformation } from '../interface/shipping-info';
import { TaxType } from '../interface/tax-type.interface';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { CreateTicketRequest } from '../interface/ticketingsystem/ticket-create';
import { WorkTicket } from '../interface/ticketingsystem/work-ticket';
import { DeleteModal } from '../models/delete-modal';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { OrderStatus } from '../models/order-status-model';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { AppConfigService } from '../services/app-config.service';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from '../services/department.service';
import { OrderService } from '../services/order.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { TrackingModel } from '../models/tracking-model';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { OrderSourceTypes } from '../enums/order-source.enum';
import { CheckoutConfig } from '../interface/checkout-config.interface';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { ReasonModel } from '../interface/ticketingsystem/reasons.modal';
import { StoreMetaDataConstants } from '../constants/store-metadata.constants';
import { SearchRequest } from "../interface/search-request";
import { catchError, concatMap, debounceTime, map, takeUntil } from 'rxjs/operators';
import { MemberSearchByFboIdResponse } from "../interface/member-search-by-fboid-response";
import { FBOResponse } from '../interface/fbo-response';
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { Months } from '../enums/months.enum';
import { MemberActivityLogType } from '../../shared/common/enumerations';
import { ActivityLogKey } from '../interface/activityLogKey';
import { Subject } from 'rxjs';
import { BonusStatusOptions } from '../interface/bonus-information';
import { BonusConstants } from '../constants/bonus-status.constants';
import { constants } from 'os';
import { switchMap } from 'rxjs/operators';
import { MemberAllowedCountries } from '../../shared/interface/member-allowed-countries.interface';
import { Country } from '../models/country.model';
import { OrderStatuses } from '../../common/enums/orderStatus.enum';
import { PersonalInfoConfigService } from '../services/personal-info-config.service';
// import { GovernmentIdentificationType } from '../enums/government-identification-type.enum';



@Component({
    selector: 'recent-order-view',
    templateUrl: '../templates/template1/views/recent-order-view.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/order-view.less','../templates/template1/themes/default/less/print-preview.less'
    ]
})
export class RecentOrderViewComponent implements OnInit,OnDestroy {
    @Input() fboid: string;
    @Input() distributorInfo: DistributorInfo;
    @Input() orderInfo: OrderInfoTab;
    isDesc: boolean = false;
    sortColumn: string = "orderDate";
    paymentInfo: boolean = false;
    orderInformation: any;
    storeInfo: any;
    phoneNumberFormat: string;
    tickets: Array<WorkTicket> = []
    ticketsIsDesc: boolean = false;
    ticketsSort: string = "ASC";
    ticketsSortColumn: string = "ID";
    ticketsPageNumber: number = 1;
    ticketsPageSize: number = 10;
    ticketsPageCount: number = 0;
    isTicketView: boolean;
    isTicketCreate: boolean;
    memberAddressDetails: any;
    deleteModal: DeleteModal;
    trackShipmentsURL: string;
    shipTrackingUrl: string;
    memberInfo:any;
    orderStatuses: Array<OrderStatus> = []
    states: any[] = [];
    countries: Array<Country> = [];
    orderNotes: any[] = [];
    orderLogs: any[] = [];
    shippingAddressInfo: any;
    displayUserName:Boolean = false;
    paymentType: any = PaymentMethodTypes;
    showprint = false;
    memberBasicInfo: any;
    storeMetadata: any;
    participatingCountries: ParticipatingCountries[] = [];
    paymentStatusEnum = PaymentStatusId;
    showCancelIcon = true;
    shipToAddressName : string;
    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];
    FBOManageOrderPermissions: number[] = [
        Permission.REGULAR_ORDER_MANAGE,
        Permission.REGULAR_ORDER_CANCEL,
        Permission.POS_ORDER_MANAGE,
        Permission.POS_ORDER_CANCEL
    ];
    ServiceOrderPermissions: number[] = [
        Permission.REPLACEMENT_ORDER_CREATE,
        Permission.REPLACEMENT_ORDER_MANAGE,
        Permission.REPLACEMENT_ORDER_CANCEL
    ];
    RefundPermissions: number[] =[
        Permission.REGULAR_ORDER_REFUND,
        Permission.POS_ORDER_REFUND
    ];
    commissionActivtiesPermissions: number[]=[
        Permission.COMMISSION_ACTIVITIES
    ]
    FboIDSearchForm:FormGroup;
    orderStatusId: any = OrderStatusEnums;
    @ViewChild('cancelOrderModal') cancelOrderModal: Modal;
    @ViewChild('orderNotesModal') orderNotesModal: Modal;
    @ViewChild('updateFboIdOfAnOrderModal') updateFboIdOfAnOrderModal:Modal
    @ViewChild('confirmOrSuccessFboIdOfAnOrderModal') confirmOrSuccessFboIdOfAnOrderModal:Modal;
    @ViewChild('cancelOrderResponseModal') cancelOrderResponseModal:Modal;
    @ViewChild('processingPeriodModal') processingPeriodModal:Modal;
    orderCancelForm: FormGroup;
    orderNotesForm: FormGroup;
    userInfo: UserInfo;
    operatingCountry: number = 57;
    departmentId: number;
    hasManageOrderPermission: boolean;
    hasCancelOrderPermission: boolean;
    hasCancelPOSOrderPermission: boolean;
    hasManageServiceOrderPermission: boolean;
    hasCancelServiceOrderPermission: boolean;
    hasManageOrderUpdatePermission: boolean;
    hasCommissionActvityPermission:boolean;
    showCCSnapshot: boolean;
    AccountTypeConstants: Constants = AccountTypeConstants;
    accountTypeEnums = AccountType;
    gstTax: number;
    pstTax: number;
    deliveryPreference = DeliveryPreference;
    retailSubTotal = 0.0;
    memberTypeId: number;
    memberTypeEnums = MemberTypeEnum;
    ticketTypeId: number;
    paymentMethodTypeConstants: Constants = PaymentMethodTypeConstants;
    appConfig: AppCountryConfig;
    orderTicketsId ="orderTicketsId";
    showDeliveryInstructions: boolean;
    shippingAddressInfoConfig: ShippingAddressInfoConfig;
    maxlimit = environment.maxlimit;
    accountCreateNotification = false;
    // memberGovernmentIdentifiations: any[];
    orderTypeId: number;
    purchaseFlowEnum = PurchaseFlow;
    printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
    achPaymentInfo:any;
    enableCloneOrderFeature:boolean;
    taxType = TaxType;
    isTitanEnabled: boolean;
    memberId: number;
    memberStatus:any;
    @ViewChild('MemberRestrictions') memberRestrictions: Modal;
    enableServiceOrder = environment.enableServiceOrder;
    OrderLineItemTypeEnum = OrderLineItemTypeEnum;
    trackingModel:TrackingModel;
    trackingUrls=[];
    orderSources = OrderSourceTypes;
    shippingCost: number;
    checkoutConfig: CheckoutConfig;
    showPrintOption:boolean = false;
    hasRegularOrderRefundPermission = false;
    hasPOSOrderRefundPermission = false;
    isCancelAlone: boolean;
    isCancelCheckBoxDisabled = false;
    isCancelAndRefundCheckBoxDisabled = false;
    orderStatusChangeReasons:ReasonModel[]=[];
    refundAmountInfo:any;
    refundAmount = 0.0;
    paymentAmount =0.0;
    enablePrintInvoiceIcon = false;
    isMemberSearchSucess:boolean = false;
    distributorIDofValenceSearch:string;
    distributorDetailsForValenceSearch : FBOResponse;
    FPCOrFBONotFoundErrorMessage:boolean = false;
    errorMessage:boolean = false;
    isNotAuthorizedCountry:boolean = false;
    notAuthorizedCountryMessage:any ;
    isConfirmationModalMessage :boolean = false;
    isDistributorIdChangedSuccessMessage:boolean = false;
    formSubscription:Subscription;
    @Output() closeTabForParticularDistributor = new EventEmitter<string>();
    bonusStatuses:BonusStatusOptions[]=[];
    selectedBonusPeriod:BonusStatusOptions;
    submitProcessOrder:boolean = false;
    bonusDetails: any = {};
    ngUnsubscribe = new Subject<void>();
    showCancelAndRefundRadio:boolean;
    hasManageServiceOrderUpdatePermission: boolean;
    orderLevelDiscount =0.0;
    retailDeliveryFee: number;
    billingAddressMode: any;
    orderTypeIdForRetail = Constants.RETAIL_ORDER_TYPE_ID;
    systemOrderNumberAcknowledgedFromAs400 = false;
    AcknowledgeType = 57; // System Order Number Received From AS400
    constructor(private _customerservice: CustomerService, private departmentService: DepartmentService
        , private messageService: MessageService, private _commonService: CommonService,
        private _orderservice: OrderService, private _translatePipe: TranslateService,
        private _formbuilder: FormBuilder,
        private _cacheService: CacheService, private _appConfigService: AppConfigService,
        private _shippingAddressInfoConfigService: ShippingAddressInfoConfigService,
        @Inject(DOCUMENT) private documentRef: Document,
        private _documentService: DocumentService,
        private _checkoutConfigService: CheckoutConfigService,
        private personalInfoConfigService: PersonalInfoConfigService
        ) {
    }
    ngOnInit(): void {
        // this.memberGovernmentIdentifiations=[];
        if (!this.orderInfo.emailID) {
            this.getStoreInfo(this.orderInfo.homeCountry);
            this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"),AccessLevel.Customer_Service);
            this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"),AccessLevel.Customer_Service);
            this.hasCommissionActvityPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("["+ this.commissionActivtiesPermissions+"]"),AccessLevel.Customer_Service);
            const billingAddress = this.personalInfoConfigService.getSettings(this.orderInfo.homeCountry);
            this.billingAddressMode = billingAddress && billingAddress.billingAddressMode? billingAddress.billingAddressMode : false;
            this.subscribeDisputeTickets();
            this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
                this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
            this.deleteModal.viewActionButtons = false;
            this.getCountries();
            this.getStates();
            this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        } else {
            this.accountCreateNotification = true;
        }
        if(this.appConfig.removeCancelAndRefund){
            this.showCancelAndRefundRadio = false;
        }
        else{
            this.showCancelAndRefundRadio = true;
        }
    }

    getTicketTypesAndSubTypes() {
        this.departmentService.getTicketTypesAndSubTypes(this.operatingCountry).subscribe(response => {
            if (response) {
                const ticketType = response.find((type: any) => type.value === TicketType.Order);
                if (ticketType) {
                    this.ticketTypeId = ticketType.id;
                }
            }
        });
    }
    /**
     * Gets fbo / retail oder information
     */
    getRecentOrderInformation() {
        this._orderservice.getRecentOrderInformation(this.orderInfo.webOrderID).subscribe(response => {
            if (response) {
                this.orderInformation = response;
                if(this.orderInformation && this.orderInformation.orderStatusId){
                    if(this.orderInformation.orderStatusId === this.orderStatusId.Completed){
                        this.enablePrintInvoiceIcon= true;
                    }
                    this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.orderInformation.countryCode);
                }
                if (this.orderInformation && this.orderInformation.orderStatusId) {
                    if (this.orderInformation.orderStatusId === OrderStatuses.Refunded) {

                        let total = 0;
                        this._orderservice.getRefundAmount(this.orderInfo.webOrderID).subscribe(res => {
                            if (res && res.length > 0) {
                                this.refundAmountInfo = res;
                                this.refundAmountInfo.forEach(item => {
                                    if (item.refundAmount != null) {
                                        total += item.refundAmount;
                                    }
                                });
                                this.refundAmount = total;
                            }
                        });
                    }
                }
                if(this.orderInformation.orderPayments) {
                    this.orderInformation.orderPayments.forEach( x=> {
                        if(x.paymentAmount !=null) {
                            this.paymentAmount += x.paymentAmount
                        }
                    })
                }
                this.orderTypeId = this.orderInformation.orderTypeId;
                this.trackingModel=response.trackingModel;
                    if(this.trackingModel){
                      for (let [key, value] of Object.entries(this.trackingModel)) {
                        if(value){
                        this.trackingUrls.push(value);}}
                    }
                if (this.orderInformation && this.orderInformation.taxMetaData
                    && this.orderInformation.taxMetaData.orderTaxCharges
                    && this.orderInformation.taxMetaData.orderTaxCharges.length > 0) {
                    const gst = this.orderInformation.taxMetaData
                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.GST_TAX);
                    const pst = this.orderInformation.taxMetaData
                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.PST_TAX);
                    this.gstTax = gst ? gst.taxAmount : 0;
                    this.pstTax = pst ? pst.taxAmount : 0;
                }
                if(response.isDM){
                   this.orderInformation.totalDiscountAmount=response.totalDiscountAmount && response.totalDiscountAmount>0?response.totalDiscountAmount:null;
                 }
                // PS2020-489 --> USA Tax issue
                if(this.orderInformation && (!this.orderInformation.orderTax || this.orderInformation.orderTax <= 0)
                    && this.orderInformation.countryCode === IsoCodeThree.USA && this.orderInformation.taxMetaData
                    && this.orderInformation.taxMetaData.orderTaxCharges
                    && this.orderInformation.taxMetaData.orderTaxCharges.length > 0){
                        const slsTax = this.orderInformation.taxMetaData
                            .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.SLS_TAX);
                        this.orderInformation.orderTax = slsTax ? slsTax.taxAmount : 0;
                }
                this.orderLevelDiscount= this.orderInformation.orderLevelDiscount;
                this.retailDeliveryFee = this.orderInformation.retailDeliveryFee ? this.orderInformation.retailDeliveryFee : 0;
                this.retailSubTotal = 0.0;
                this.orderInformation.orderLineItems.forEach(item => { this.retailSubTotal = (this.retailSubTotal + item.totalRetailPrice) });

                if (this.orderInformation && this.orderInformation.userName && (this.orderInformation.source === Constants.CUSTOMER_SERIVCE || this.orderInformation.source === Constants.POS_ORDER || this.orderInformation.source === Constants.SERVICE_ORDER)) {
                    this.displayUserName = true;
                }
                if (this.orderInformation && this.orderInformation.distrubutorId &&
                     (this.orderStatusId.Failed === this.orderInformation.orderStatusId)) {
                    this.enableCloneOrderFeature = this._commonService.isenableCloneOrderCountries(this.orderInformation.countryCode);
                } else {
                    if (this.orderStatusId.Failed === this.orderInformation.orderStatusId){
                        const warningMessage: any = this._translatePipe.get('common.Enrollment Failed,so we cannot allow to clone the order');
                        this._commonService.createNotification('', warningMessage.value, NotificationType.ERROR);
                    }

                }

                this.getMemberInformation();
                if (this.orderInformation.orderStatusId === OrderStatusEnums.In_Complete) {
                    this.orderInformation.orderStatusId = OrderStatusEnums.Accepted;
                }
                const orderStatus = this.orderStatuses.find((status: OrderStatus) => status.id === this.orderInformation.orderStatusId);
                this.orderInformation.orderStatus = orderStatus ? orderStatus.description : '';
                this.checkoutConfig = this._checkoutConfigService.getSettings(this.orderInfo.homeCountry, this.memberInfo);
                if (this.orderInformation.orderGroupId !== OrderType.REPLACEMENT && this.orderInformation.orderGroupId !== OrderType.POS) {
                    this.hasManageServiceOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ServiceOrderPermissions + "]"),AccessLevel.Customer_Service);
                }
                if (this.orderInformation.orderGroupId === OrderType.REGULAR) {
                    this.hasManageOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageOrderPermissions[0] + "]"),AccessLevel.Customer_Service);
                    this.hasCancelOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageOrderPermissions[1] + "]"),AccessLevel.Customer_Service);
                    this.hasCancelPOSOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageOrderPermissions[3] + "]"),AccessLevel.Customer_Service);
                    this.hasPOSOrderRefundPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.RefundPermissions[1] + "]"),AccessLevel.Customer_Service);
                    this.hasRegularOrderRefundPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.RefundPermissions[0] + "]"),AccessLevel.Customer_Service);
                    if(this.storeInfo && this.storeMetadata && this.storeMetadata.length > 0) {
                    let hasOrderUpdatePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.ORDER_STATUS_UPDATE + "]"),AccessLevel.Store,this.storeInfo ? this.storeInfo.id : null);
                    let orderStatusUpdateAttribute = this.storeMetadata.find(x => (x.attribute &&
                            x.attribute.toLowerCase() === StoreMetaDataConstants.ENABLE_ORDER_STATUS_UPDATE.toLowerCase()));
                    let storeOrderUpdateFeatureEnabled : boolean = orderStatusUpdateAttribute && orderStatusUpdateAttribute.metaDataValue && orderStatusUpdateAttribute.metaDataValue === 'true' ? true : false;
                   this.hasManageOrderUpdatePermission = hasOrderUpdatePermission && storeOrderUpdateFeatureEnabled;
                    }
                }
                if (this.orderInformation.orderGroupId === OrderType.REPLACEMENT) {
                    this.hasCancelServiceOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ServiceOrderPermissions[2] + "]"),AccessLevel.Customer_Service);

                    this.hasManageServiceOrderUpdatePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ServiceOrderPermissions[1]+ "]"),AccessLevel.Customer_Service);
                    if(this.storeInfo && this.storeMetadata && this.storeMetadata.length > 0) {
                        let hasServiceOrderUpdatePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.REPLACEMENT_ORDER_STATUS_UPDATE + "]"),AccessLevel.Customer_Service);
                        let orderStatusUpdateAttribute = this.storeMetadata.find(x => (x.attribute &&
                                x.attribute.toLowerCase() === StoreMetaDataConstants.ENABLE_SERVICE_ORDER.toLowerCase()));
                        let storeOrderUpdateFeatureEnabled : boolean = orderStatusUpdateAttribute && orderStatusUpdateAttribute.metaDataValue && orderStatusUpdateAttribute.metaDataValue === 'true' ? true : false;
                        let isPickupOrder = this.orderInformation.orderShippings[0].deliveryPreferenceId === ShippingType.PICKUP?true:false;
                       this.hasManageOrderUpdatePermission = (hasServiceOrderUpdatePermission && isPickupOrder)&& storeOrderUpdateFeatureEnabled;
                                }
                    }

                //verifying wether respective fields are undefined or not.. if undefined assigning respective model
                if (!this.orderInformation.billingInfo) {
                    this.orderInformation.billingInfo = new BillingInformation();
                    this.orderInformation.billingInfo.address = new AddressInformation();
                }
                if (!this.orderInformation.shippingInfo) {
                    this.orderInformation.shippingInfo = new ShippingInformation();
                    this.orderInformation.shippingInfo.address = new AddressInformation();
                }
                else if (response.shippingInfo.shippingDate) {
                    this.orderInformation.shippingInfo.shippingDate = new Date(response.shippingInfo.shippingDate);

                }
                if (this.orderInformation.orderShippings.length > 0 && this.orderInformation.orderShippings[0].billingAddressId) {
                    let addressId = this.orderInformation.orderShippings[0].billingAddressId;
                    // this.getAddressInfo(addressId, true);
                }
                else if (this.orderInformation.orderShippings.length > 0 && this.orderInformation.orderShippings[0].shippingAddressId) {
                    let addressId = this.orderInformation.orderShippings[0].shippingAddressId;
                    // this.getAddressInfo(addressId, true);
                }
                if (this.orderInformation.orderShippings.length > 0 && !this.orderInformation.shippingInfo.warehouse) {
                    this.orderInformation.shippingInfo.warehouse = this.orderInformation.orderShippings[0].distributionCenter;
                }

                if (this.orderInformation && this.orderInformation.storePostedOffset === 0) {
                    if (this.orderInformation && this.orderInformation.createdDate !== null) {
                        this.orderInformation.createdDate = moment.utc(this.orderInformation.createdDate).format('DD-MMM-YYYY HH:mm:ss'); 
                    }
                    if (this.orderInformation && this.orderInformation.orderPostedDate !== null) {
                        this.orderInformation.orderPostedDate = moment.utc(this.orderInformation.orderPostedDate).format('DD-MMM-YYYY HH:mm:ss');
                    }
                }
                else {
                    if (this.orderInformation && this.orderInformation.createdDate !== null && this.orderInformation.storePostedOffset) {
                        this.orderInformation.createdDate = moment.utc(this.orderInformation && this.orderInformation.createdDate)
                            .utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss'); 
                    }
                }
                if (this.orderInformation && this.orderInformation.orderPostedDate !== null && this.orderInformation.storePostedOffset) {
                    this.orderInformation.orderPostedDate = moment.utc(this.orderInformation && this.orderInformation.orderPostedDate)
                    .utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss'); 
                }
                // calculating shipping cost and shippingTax based on calculateShippingWithTax flag.
                this.getShippingCostWithShippingTax();
                if (this.orderInformation.orderShippings.length > 0) {
                    this.shippingAddressInfo = null;
                    this.memberAddressDetails = [];
                    this.orderInformation.addresses.forEach((address: any) => {
                        this.memberAddressDetails.push({
                            id: address.id,
                            shippingAddress: {
                                shipToName: address.name,
                                addressLine1: address.addressLine1,
                                addressLine2: address.addressLine2,
                                addressLine3: address.addressLine3,
                                addressLine4: address.addressLine4,
                                addressType: address.addressType,
                                firstName: address.firstName,
                                lastName: address.lastName,
                                middleName: address.middleName,
                                city: address.city,
                                stateId: address.stateId,
                                countryId: address.countryId,
                                postalCode: address.postalCode,
                                addressVerified: address.addressVerified,
                                shippingPhone: address.phone,
                                email: address.email,
                                phoneType: address.phoneType,
                                deliveryInstruction: address.deliveryInstruction,
                                phone: address.phone
                            }
                        });
                    });
                    this.showDeliveryInstructions = (this.appConfig && this.appConfig.enableDeliveryInstructions)? this.appConfig.enableDeliveryInstructions:false;
                    if (this.memberAddressDetails.length > 0) {
                        const shippingAddressDetails = this.memberAddressDetails.find((address: any) =>
                            (address.shippingAddress.addressType ===  AddressType.SHIPPING) ||(address.shippingAddress.addressType ===  AddressType.PICKUP_PERSON) || (address.shippingAddress.addressType ===  AddressType.PICKUP)||(address.shippingAddress.addressType ===  AddressType.DROPSHIP));
                        if (shippingAddressDetails) {
                            this.shippingAddressInfo = shippingAddressDetails.shippingAddress;
                            this.orderInformation.shippingInfo.address.addressLine1 = this.shippingAddressInfo.addressLine1;
                            this.orderInformation.shippingInfo.address.addressLine2 = this.shippingAddressInfo.addressLine2;
                            this.orderInformation.shippingInfo.address.addressLine3 = this.shippingAddressInfo.addressLine3;
                            this.orderInformation.shippingInfo.address.addressLine4 = this.shippingAddressInfo.addressLine4;
                            this.orderInformation.shippingInfo.address.zipCode = this.shippingAddressInfo.postalCode;
                            this.orderInformation.shippingInfo.address.city = this.shippingAddressInfo.city;
                            this.orderInformation.shippingInfo.address.name = this.shippingAddressInfo.shipToName;
                            this.orderInformation.shippingInfo.address.firstName = this.shippingAddressInfo.firstName;
                            this.orderInformation.shippingInfo.address.middleName = this.storeInfo && this.storeInfo.displayMiddleName && this.shippingAddressInfo.middleName ? this.shippingAddressInfo.middleName : '';
                            this.orderInformation.shippingInfo.address.lastName = this.shippingAddressInfo.lastName;
                            this.orderInformation.shippingInfo.address.state = this.getStateByStateId(this.shippingAddressInfo.stateId);
                            this.orderInformation.shippingInfo.address.country = this.getCountryByCountryId(this.shippingAddressInfo.countryId);
                            this.orderInformation.shippingInfo.address.deliveryInstruction = this.shippingAddressInfo.deliveryInstruction;
                            this.orderInformation.shippingInfo.address.email = this.shippingAddressInfo.email ? this.shippingAddressInfo.email : null;
                            this.orderInformation.shippingInfo.address.phone = this.shippingAddressInfo.phone ? this.shippingAddressInfo.phone : null;
                        }
                    }
                }

                if (!this.orderInformation.orderLineItems) {
                    this.orderInformation.orderLineItems = new Array<ProductInformation>();
                }

                if (this.orderInformation.orderShippings.length > 0 && this.orderInformation.orderShippings[0].shipMethodId) {
                    this.getShippingMethodInfo(this.orderInformation.storeId, this.orderInformation.orderShippings[0].shipMethodId);
                }
                const filteredCountry = this.countries.find(country =>
                    country.isocodeThree.toLowerCase() === this.orderInformation.countryCode.toLowerCase());
                 let isoCodeTwo = '';
                 if (filteredCountry && filteredCountry.isocodeTwo) {
                   isoCodeTwo = filteredCountry.isocodeTwo;
                 }
                 let postalCode = '';
                 if (this.shippingAddressInfo && this.shippingAddressInfo.postalCode) {
                    postalCode = this.shippingAddressInfo.postalCode.replace('-', '');
                 }
                //  Generating Tracking Shipments Url
                if (this.orderInformation.orderShippings && this.orderInformation.orderShippings.length
                     && this.orderInformation.orderShippings[0].shipmentId) {
                    this.trackShipmentsURL = environment.trackShipmentsURL + '?link=1&dest_cntry=' + isoCodeTwo
                    + '&dest_postal=' + postalCode + '&tracknumbers=' + this.orderInformation.orderNumber
                     + '&account_number=' + this.orderInformation.orderShippings[0].shipmentId + '&cntry_code=' + isoCodeTwo;
                }

                if (this.orderInformation.orderShippings.length > 0 && (this.orderInformation.orderShippings[0].deliveryPreferenceId ===
                    DeliveryPreference.PICKUP || this.orderInformation.orderShippings[0].deliveryPreferenceId ===
                    DeliveryPreference.DROPSHIP)) {
                    if (this.orderInformation.addresses.length > 1) {
                        const address =   this.orderInformation.addresses.filter(item => item.addressType === AddressType.PUDO || item.addressType === AddressType.PICKUP);
                        if (address) {
                            address.some(element => {
                                if (element && element.addressLine1) {
                                this.orderInformation.shippingInfo.address.addressLine1 = element.addressLine1;
                                this.orderInformation.shippingInfo.address.addressLine2 = element.addressLine2;
                                this.orderInformation.shippingInfo.address.zipCode = element.postalCode;
                                this.orderInformation.shippingInfo.address.city = element.city;
                                this.orderInformation.shippingInfo.address.name = element.name;
                                this.orderInformation.shippingInfo.address.state = element.stateCode;
                                this.orderInformation.shippingInfo.address.country = element.countryCode;
                                this.shipToAddressName=element.name;
                                this.orderInformation.shippingInfo.warehouse = element.name;
                                }
                            });
                        }
                    } else {
                        this._orderservice.getPickupAddressInformation(this.orderInformation.orderShippings[0].shipMethodId,
                            this.orderInformation.storeId).subscribe(sresponse => {
                                if (sresponse) {
                                    this.orderInformation.shippingInfo.warehouse = sresponse.centerName;
                                    this.orderInformation.shippingInfo.address.addressLine1 = sresponse.addressDetailModel.addressLine1;
                                    this.orderInformation.shippingInfo.address.addressLine2 = sresponse.addressDetailModel.addressLine2;
                                    this.orderInformation.shippingInfo.address.zipCode = sresponse.addressDetailModel.postalCode;
                                    this.orderInformation.shippingInfo.address.city = sresponse.addressDetailModel.city;
                                    this.orderInformation.shippingInfo.address.name = sresponse.centerName;
                                    this.orderInformation.shippingInfo.address.state = sresponse.addressDetailModel.stateCode;
                                    this.orderInformation.shippingInfo.address.country = sresponse.addressDetailModel.countryCode;
                                    this.shipToAddressName=sresponse.centerName;
                                }
                            });
                    }
                }
                if(this.orderInformation && this.orderInformation.orderWaved != null && this.orderInformation.orderWaved){
                    this.showCancelIcon = false;
                }
                if(this.orderInformation && this.orderInformation.orderPayments && this.orderInformation.orderPayments.length > 0){
                    const orderPayment = this.orderInformation.orderPayments[0];
                    const paymentStatusId = orderPayment.paymentStatusId;
                    if(paymentStatusId && (paymentStatusId == this.paymentStatusEnum.REFUND_INITIATED || paymentStatusId == this.paymentStatusEnum.CANCEL_INITIATED || paymentStatusId == this.paymentStatusEnum.CANCEL_OR_REFUND_INITITATED)){
                        this.showCancelIcon = false;
                    }
                }

                if(this.orderInfo && this.orderInfo.newOrder){
                    if (this.orderInformation.orderStatusId === OrderStatusEnums.Failed) {
                        const notification: any = this._translatePipe.get('order.Order creation failed');
                        this._commonService.setNotification('', notification.value, 'error', 0, false, 500);
                    } else if (this.orderInformation.orderStatusId !== OrderStatusEnums.Cancelled) {
                        const notification: any = this._translatePipe.get('order.Order created successfully');
                        this._commonService.setNotification('', notification.value, 'success', 0, false, 500);
                    }
                }
                setTimeout(() => {
                    this.getOrderPaymentInfo(this.orderInfo.webOrderID, this.orderInformation.id);
                }, 300);
                this.getDisputeTickets();
                this.getOrderNotes();
                this.getOrderLogs();
                this.getShippingTrackURL(this.orderInfo.webOrderID);
                this._customerservice.getParticipatingCountries(this.orderInformation.countryCode).subscribe((countryResponse) => {
                    this.participatingCountries = countryResponse;
                });
                // this.getMemberRegisterAddress(this.orderInformation.memberId);
                this.disableCancelIcon();
            }
        });
    }

    /**
     * Disable Cancel Icon
     */
    disableCancelIcon(): void {
        if (((this.hasCancelPOSOrderPermission || this.hasPOSOrderRefundPermission)
            // && (this.orderStatusId.Processing == this.orderInformation.orderStatusId)
            && (this.orderStatusId.Cancelled !== this.orderInformation.orderStatusId && this.orderStatusId.Failed !== this.orderInformation.orderStatusId)
            && (this.orderInformation.source === this.orderSources.POS))) {
                this.showCancelIcon = true;
        } else if ((
            ((((this.orderInformation.orderGroupId !== OrderType.REPLACEMENT)
                && (this.orderInformation.source !== this.orderSources.POS))
                && (this.hasCancelOrderPermission || this.hasRegularOrderRefundPermission))
            || (this.orderInformation.orderGroupId === OrderType.REPLACEMENT && (this.hasCancelServiceOrderPermission)))
            && (this.orderStatusId.Cancelled != this.orderInformation.orderStatusId && this.orderStatusId.Failed != this.orderInformation.orderStatusId)
            && (!this.orderInfo.tabForOrderPromotion) && this.showCancelIcon)) {

                this.showCancelIcon = true;

        } else {
            this.showCancelIcon = false;
        }
    }

    // getMemberRegisterAddress(memberId: any) {
    //     this._customerservice.getMemberBasicInfoById(memberId).subscribe((memberResponse) => {
    //         if (memberResponse) {
    //             this.memberBasicInfo = memberResponse;
    //         }
    //     });
    // }

    /**
     * Get Store Info
     * @param countryCode
     */
    getStoreInfo(country: any) {

        const countryCode=(country && country!='')?country:this.orderInformation?this.orderInformation.countryCode:null;
        if (countryCode) {
            this.appConfig = this._appConfigService.getSettings(countryCode, this.memberInfo);
            this.shippingAddressInfoConfig = this._shippingAddressInfoConfigService.getSettings(countryCode);
            this._orderservice.getStoreInfo(countryCode).subscribe(response => {
                if (response) {
                    this.storeInfo = response;
                    this.getStoreMetaData(this.storeInfo.id);
                    this.getOrderStatuses();
                    this.saveAgreementDocuments(this.orderInfo);
                    if (this.orderInformation && this.orderInformation.storePostedOffset === 0) {
                        if (this.orderInformation && this.orderInformation.createdDate !== null) {
                            this.orderInformation.createdDate = moment.utc(this.orderInformation.createdDate).format('DD-MMM-YYYY HH:mm:ss');
                        }
                        if (this.orderInformation.orderPostedDate !== null) {
                            this.orderInformation.orderPostedDate = moment.utc(this.orderInformation.orderPostedDate).format('DD-MMM-YYYY HH:mm:ss');
                        }
                    }
                    else {
                        if (this.orderInformation && this.orderInformation.createdDate !== null && this.orderInformation.storePostedOffset) {
                            this.orderInformation.createdDate = moment.utc(this.orderInformation && this.orderInformation.createdDate)
                                .utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                        }
                    }
                    if (this.orderInformation && this.orderInformation.orderPostedDate !== null && this.orderInformation.storePostedOffset) {
                        this.orderInformation.orderPostedDate = moment.utc(this.orderInformation && this.orderInformation.orderPostedDate)
                            .utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                    }
                }
            }, error => {
                const notification: any = this._translatePipe.get('order. Unable to fetch Store Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }

    }

    /*
    get Dispute Tickets created on selected web order Id.
     */
    getDisputeTickets() {
        var weborderId = this.orderInfo.webOrderID ? this.orderInfo.webOrderID : this.orderInfo.orderNumber;
        this._customerservice.SearchTicketsOnPagination(null, null, null, null, null, null, null, null, null, this.ticketsPageNumber, this.ticketsPageSize, this.ticketsSortColumn, this.ticketsSort, weborderId).subscribe((response: WorkTicket[]) => {
            if (response) {
                this.tickets = response["content"];
                this.ticketsPageCount = response['totalCount'];
            } else {
                this.tickets = [];
                this.ticketsPageCount = 0
            }

        });
    }
    /**
 * sorting of columns // not hits service...
 * @param sortColumn
 */
    sortOrderInformationByColumn(sortColumn: string) {
        let productitems: Array<ProductInformation>;
        productitems = this.orderInformation.productInfo;
        this.isDesc = (this.sortColumn == sortColumn || sortColumn == "") ? !this.isDesc : this.isDesc;
        productitems.sort((a, b) => {
            if (a[sortColumn] > b[sortColumn])
                return this.isDesc ? -1 : 1;

            if (a[sortColumn] < b[sortColumn])
                return this.isDesc ? 1 : -1;
        });
        this.sortColumn = sortColumn;
    }
    /*
      sort dispute tickets by column
       */
    sortTicketsByColumn(sortColumn: string) {
        this.ticketsIsDesc = (this.ticketsSortColumn == sortColumn) ? !this.ticketsIsDesc : this.ticketsIsDesc;
        this.ticketsSort = this.ticketsIsDesc ? "DESC" : "ASC";
        this.ticketsSortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.tickets.length === 0) {
            return;
        }
        this.getDisputeTickets();
        this.getOrderNotes();
        this.getOrderLogs();

    }
    /*
   get dispute tickets on page change
    */
    ticketsPageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            this.ticketsPageNumber = pageNumber;
            this.getDisputeTickets();
            this.getOrderNotes();
            this.getOrderLogs();

        }
    }
    /*
      * To update tickets in the order history once updated
    */
    subscribeDisputeTickets() {
        this.messageService.getDisputeTickets().subscribe((data: any) => {
            if (data) {
                this.getDisputeTickets();
                this.getOrderNotes();
                this.getOrderLogs();
            }
        });
    }


    getOrderPaymentInfo(webOrderId: any, orderId: any) {
        this._customerservice.getPaymentInfo(webOrderId, orderId).subscribe((response: any) => {
            if (response) {
                this.paymentInfo = true;
                this.orderInformation.billingInfo = response;
                this.achPaymentInfo = response;
            }
            //if(this.achPaymentInfo.dlState){
                //this.getStateByStateCodeAndCountryCode(this.achPaymentInfo.dlState,this.orderInformation.countryCode)
           // }
           this.showPrintOption = true;
        }, error => {
            this.paymentInfo = false;
            this.showPrintOption = true;
        });
    }
    /*create new ticket*/
    createDisputeTicket() {
        if (this.isTicketCreate) {
            let ticketTab = new TicketTabInfo();
            ticketTab.distributorID = this.fboid;
            ticketTab.isNewTicket = true;
            ticketTab.title = "Create Ticket";
            ticketTab.country = this.orderInfo.homeCountry;
            ticketTab.webOrderID = this.orderInfo.webOrderID || this.orderInfo.orderID;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        } else {
            this.displayAlertbox();
        }
        //this.tabId++;
    }
    /*
      view or edit Dispute tickets in new tab
       */
    goToViewTicket(id: any, ticketNumber: any) {

        if (this.isTicketView) {
            let ticketTab = new TicketTabInfo();
            ticketTab.distributorID = this.distributorInfo.distributorId;
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = "View Ticket - " + ticketNumber;
            ticketTab.viewTicket = true;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
    }
    /**
       * display alert box if the logged in user do not have permission to see the fbo/retail information
       */
    displayAlertbox() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    }
    doNotRemoveFormData() {
        //data should not be removed...
    }
    /*
    get different order statuses
     */
    getOrderStatuses() {
        Object.entries(OrderStatuses).forEach(([key, value]) => this.orderStatuses.push({id : +value, description : key}));
        this.getRecentOrderInformation();
    }

    saveAgreementDocuments(orderIndo: OrderInfoTab) {
        if (orderIndo && orderIndo.acceptDocuments && orderIndo.acceptDocuments.memberTypeId
            && orderIndo.acceptDocuments.memberId && orderIndo.acceptDocuments.documents
            && orderIndo.acceptDocuments.documents.length) {
            orderIndo.acceptDocuments.documents.forEach(document => {
                this._documentService.updateAcknowledgedDocuments(document, orderIndo.acceptDocuments.memberTypeId, orderIndo.acceptDocuments.memberId).subscribe(
                    (res)=>{

                    }
                );
            });
        }
    }
    /**
     * get billing information
     * @param addressId
     */
    getAddressInfo(addressId: number, billingAddressId?: boolean) {
        this._orderservice.getBillingInfo(addressId).subscribe((response) => {
            if (response.length > 0 && !billingAddressId) {
                this.orderInformation.shippingInfo.address.addressLine1 = response[0].addressLine1;
                this.orderInformation.shippingInfo.address.addressLine2 = response[0].addressLine2;
                this.orderInformation.shippingInfo.address.zipCode = response[0].postalCode;
                this.orderInformation.shippingInfo.address.city = response[0].city;
                this.orderInformation.shippingInfo.address.name = response[0].shipToName;
                this.orderInformation.shippingInfo.address.state = this.getStateByStateId(response[0].stateId);
                this.orderInformation.shippingInfo.address.country = this.getCountryByCountryId(response[0].countryId);
            }
        });
    }
    /**
     * Get State Info by Code or Id
     * @param stateId
     *
     */
    private getStateByStateId(stateId: number): string {
        let stateName = "";
        if (stateId) {
            let stateObj = this.states.find((x: any) => x.id === stateId);
            stateName = stateObj ? stateObj.stateName : '';
        }
        return stateName;
    }

    /**
     * get States
     */
    getStates() {
        this._customerservice.getStates().subscribe(response => {
            if (response) {
                this.states = response;
            }
        });
    }

    /**
    * Get Country Info by Code or Id
    * @param countryId
    *
    */
    private getCountryByCountryId(countryId: number): string {
        let countryName = "";
        if (countryId) {
            let countryObj = this.countries.find((x: any) => x.countryId === countryId);
            countryName = countryObj ? countryObj.name : '';
        }
        return countryName;
    }
    /**
  * get Countries
  */
    getCountries() {
       const allCountries= JSON.parse(localStorage.getItem("appadmin.Countries"));
            if (allCountries) {
                this.countries = allCountries;
            }

    }
    /**
     * edit order
     */
    editOrder() {
        const orderUrl = window.location.origin + '/customerservice/orders/' + this.orderInfo.webOrderID.toUpperCase();
        window.open(orderUrl, "_blank");
    }

     /**
     * clone order
     */
    cloneOrder() {
        const orderUrl = window.location.origin + '/customerservice/orders/' + this.orderInfo.webOrderID.toUpperCase();
        window.open(orderUrl, "_blank");
    }


    getShippingMethodInfo(storeId: number, shippingMethodId: number) {
        this._orderservice.getShippingMethod(storeId, shippingMethodId).subscribe(response => {
            if (response) {
                let shipmentMethod = response;
                this.orderInformation.shippingInfo.shippingMethod = shipmentMethod.shippingMethodDisplayName ? shipmentMethod.shippingMethodDisplayName : 'NA';
            }
        });
    }

    /**
     * To Disable the Cancel Checkbox based on the perission
     */
     disabledCancelCheckbox(): void {
        let paymentMethodResult = this.isNotRefundablePayments();
        let isDisabledCancelCheckbox = false;
        let isDisabledCancelAndRefundCheckbox = false;
        let cancelElement: any = document.getElementById('cancel');
        let cancelAndRefundElement: any = document.getElementById('cancelAndRefund');
        if ((!((this.hasCancelOrderPermission && this.orderInformation.source !== Constants.POS_ORDER && this.orderInformation.orderGroupId !== OrderType.REPLACEMENT) ||
            (this.orderInformation.source === Constants.POS_ORDER && this.hasCancelPOSOrderPermission) ||
            (this.orderInformation.orderGroupId === OrderType.REPLACEMENT && this.hasCancelServiceOrderPermission)))) {
                if (cancelElement) {
                    cancelElement.disabled = true;
                    isDisabledCancelCheckbox = true;
                }
        }
        if ((!((!(paymentMethodResult) && this.hasRegularOrderRefundPermission && this.orderInformation.source !== Constants.POS_ORDER && this.orderInformation.orderGroupId != OrderType.REPLACEMENT) ||
                (this.orderInformation.source === Constants.POS_ORDER && this.hasPOSOrderRefundPermission) ||
                (this.orderInformation.orderGroupId === OrderType.REPLACEMENT)))) {
                if (cancelAndRefundElement) {
                    cancelAndRefundElement.disabled = true;
                    isDisabledCancelAndRefundCheckbox = true;
                }
        }

        if((paymentMethodResult== false)) {
            if (cancelAndRefundElement &&  (!(cancelAndRefundElement.disabled))) {
                if(this.paymentAmount > this.refundAmount) {
                   cancelAndRefundElement.disabled = false;
                   if(isDisabledCancelCheckbox == true) {
                       isDisabledCancelAndRefundCheckbox = false;
                    }else {
                        isDisabledCancelAndRefundCheckbox = true;
                    }
                }
                else {
                    cancelAndRefundElement.disabled = true;
                    isDisabledCancelAndRefundCheckbox = true;
                }
            }
        }else if((paymentMethodResult == true) && (cancelAndRefundElement)) {
            cancelAndRefundElement.disabled = true;
            isDisabledCancelAndRefundCheckbox = true;
        }

        if (cancelElement && cancelAndRefundElement) {
            if (!isDisabledCancelCheckbox && isDisabledCancelAndRefundCheckbox) {
                cancelElement.checked = true;
                this.onCancelOptionChange('cancel');
            } else if (isDisabledCancelCheckbox && !isDisabledCancelAndRefundCheckbox) {
                cancelAndRefundElement.checked = true;
                this.onCancelOptionChange('cancelAndRefund');
            } else if (!isDisabledCancelCheckbox && !isDisabledCancelAndRefundCheckbox) {
                cancelElement.checked = true;
                this.onCancelOptionChange('cancel');
            }
        }

    }

    /**
     * To Check whether Refundable payments or not.
     */
    isNotRefundablePayments(): boolean {
        const paymentType = this.orderInformation && this.orderInformation.billingInfo
            && this.orderInformation.billingInfo.paymentMethod ? this.orderInformation.billingInfo.paymentMethod : '';
        if (paymentType.toLowerCase() === this.paymentType.Cash.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Credit_Card_External.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Cash_On_Delivery.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Bank_Transfer.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Money_order.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Orange_Money.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Wire_Transfer.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Personal_Check.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Travelers_Check.toLowerCase() ||
           // paymentType.toLowerCase() === this.paymentType.Credit_Card.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Integrated_Terminal_Adyen.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Bonus_Check.toLowerCase()) {
                return true;
        }
        else {
            return false;
        }
    }

    /**
     * Show cancel Order
     */
    cancelOrderPopup() {
        this.buildForm();
        this.getOrderStatusChangeReason();
        this.getBonusRunStatusDetails("cancelOrder");
    }

    openCancelOrderPopup(){
      if (this.bonusDetails && this.bonusDetails.success && (this.bonusDetails.bonusStatusId == BonusStatus.OPEN || this.bonusDetails.bonusStatusId == BonusStatus.RESTRICTED)) {
        this.cancelOrderModal.open();
        setTimeout(() => {
          const orderCancelNotesElement = document.getElementById("orderStatusChangeReasonId");
          if (orderCancelNotesElement) {
              orderCancelNotesElement.focus();
          }
          this.disabledCancelCheckbox();
      }, 200);
      } else {
         this.toasterMsg("common.The bonus run status for this order's processing period is not open or restricted.",NotificationType.ERROR);
      }
    }

    /**
     * Get order status change reason based on operating country
     */
	getOrderStatusChangeReason() {
        this._orderservice.getChangeReasons(null, null, true, null, null, null, this.storeInfo.operatingCountry).subscribe(response => {
            if (response && response.totalCount > 0) {
                this.orderStatusChangeReasons = response.content;
                this.orderStatusChangeReasons.sort((a, b) => {
                    if (a.reasonNote < b.reasonNote) {
                        return -1;
                    } else if (a.reasonNote > b.reasonNote) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            } else {
                this.orderStatusChangeReasons = [];
            }
        }, () => {
            this.orderStatusChangeReasons = [];
        });
    }
    // Method for calculating the shipping cost with and without shipping tax
    // getShippingCostWithShippingTax() {
    //     // this.getVatIdfromMember();
    //     const skipShippingTaxCalculation = (this.memberInfo && this.memberInfo.vatRegistered) || this.appConfig.skipShippingTaxCalculationInShipping ;
    //     if (this.orderInformation && this.appConfig) {
    //         if (this.memberInfo && ((this.memberInfo.vatRegistered && this.orderInformation.vatRegistered) || (this.appConfig.enableVatItemizationForNonVat && this.memberInfo.memberTypeId === this.memberTypeEnums.DISTRIBUTOR)) || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice
    //             && !this.appConfig.calculateShippingWithTax)) {
    //             this.shippingCost = this.orderInformation.shippingCost;
    //         } else if (this.appConfig.calculateShippingWithTax || (!skipShippingTaxCalculation && this.orderInformation.shippingTax && !this.appConfig.enableVatItemizationForNonVat)) {
    //             this.shippingCost =  this.orderInformation.orderShippings.length > 0 && this.orderInformation.orderShippings[0].shippingWaived ?  this.orderInformation.shippingCost : this.orderInformation.shippingCost + this.orderInformation.shippingTax;
    //         } else {
    //             this.shippingCost =  this.orderInformation.orderShippings.length > 0 && this.orderInformation.orderShippings[0].shippingWaived ? this.orderInformation.shippingCost :  this.orderInformation.shippingCost;
    //         }
            
    //     }
    // }

    getShippingCostWithShippingTax() {
        if (this.orderInformation && this.appConfig) {
            if (this.memberInfo && ((this.orderInformation.vatRegistered) || (this.appConfig.enableVatItemizationForNonVat && this.orderInformation.memberTypeId === this.memberTypeEnums.DISTRIBUTOR)) || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice)
                && !this.appConfig.calculateShippingWithTax) {
                this.shippingCost = this.orderInformation.shippingCost;
            } else if (this.appConfig.calculateShippingWithTax) {
                this.shippingCost =  this.orderInformation.orderShippings[0].shippingWaived ? this.orderInformation.shippingCost : this.orderInformation.shippingCost + this.orderInformation.shippingTax;
            } else {
                this.shippingCost = this.orderInformation.shippingCost;
            }
        }
    }

    /**
     * Build Form for cancel orders
     */
    buildForm() {
        this.orderCancelForm = this._formbuilder.group({
            cancelAndRefund:[''],
            orderStatusChangeReasonId:['', [Validators.required]],
            notes: ['']
        });
    }

    /**
     * close cancel order popup
     */
    closePopup() {
        this.cancelOrderModal.close();
        this.cancelOrderResponseModal.close();
    }
    /**
    * cancel order
    */
    cancelOrder() {
        if (this.orderCancelForm.valid && (this.orderCancelForm.value.notes.trim().length > 0 || this.orderCancelForm.value.orderStatusChangeReasonId)) {
            let notes = this.orderCancelForm.value.notes
            const orderStatusChangeReasonId = this.orderCancelForm.value.orderStatusChangeReasonId;
            this.cancelOrderModal.close();
            this._orderservice.cancelOrder(this.orderInfo.webOrderID, this.isCancelAlone).subscribe(response => {
                if (response && response.success) {
                  if (this.bonusDetails &&
                    ((this.isCancelAlone &&
                      (this.bonusDetails.bonusStatusId == BonusStatus.OPEN ||
                        this.bonusDetails.bonusStatusId == BonusStatus.CLOSED_AND_PUBLISHED) ) ||
                         (!this.isCancelAlone && this.bonusDetails.bonusStatusId == BonusStatus.OPEN))){
                        this.cancelOrderResponseModal.open();
                  }
                    if ((this.orderInformation && this.orderInformation.orderPayments && this.orderInformation.orderPayments.length > 0)
                        && this.orderInformation.orderStatusId !== 1
                        && (this.orderInformation.orderPayments[0].paymentMode === PaymentMethodTypes.eCheck
                             || this.orderInformation.orderPayments[0].paymentMode === PaymentMethodTypes.Money_order
                             || this.orderInformation.orderPayments[0].paymentMode === PaymentMethodTypes.Orange_Money
                             || this.orderInformation.orderPayments[0].paymentMode === PaymentMethodTypes.Wire_Transfer )) {
                        this.createTicket(notes, this.orderInformation.orderPayments[0].paymentMode);
                    }
                    const orderStatusChangeReason = this.orderStatusChangeReasons.filter(reasonNote=> reasonNote.id == orderStatusChangeReasonId);
                    this.createOrderNote(this.orderInfo.webOrderID, orderStatusChangeReason[0].reasonNote,false, orderStatusChangeReasonId,notes);
                    this.showCancelIcon = false;
                    let notificationMessage: string = 'order.Order cancelled sucessfully';
                    if(response.orderStatusId != this.orderStatusId.Cancelled){
                        notificationMessage = 'order.Order cancel/refund initiated successfully, Please check the order logs for updated status at later time';
                    }
                    let notification: any = this._translatePipe.get(notificationMessage);
                    this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    this.getRecentOrderInformation();
                } else if (response && !response.success && response.validations && response.validations.length > 0) {
                    this._commonService.createNotification('', response.validations[0].message, NotificationType.ERROR);
                } else {
                    let notification: any = this._translatePipe.get('order.Unable to cancel Order');
                    this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            }, error => {
                let notification: any = this._translatePipe.get('order.Unable to cancel Order');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        } else {
            let notification: any = this._translatePipe.get('order.Reason is Mandatory');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
    }

  createOrderNote = (webOrderId, note, isDisplayNotification, orderStatusChangeReasonId?: number, note1?: any) => {
    this._orderservice
      .createOrderNote(
        webOrderId,
        note,
        this.userInfo.userId,
        orderStatusChangeReasonId
      )
      .pipe(
        concatMap((response) => {
          return response && response.success && note1
            ? this._orderservice
                .createOrderNote(
                  webOrderId,
                  note1,
                  this.userInfo.userId,
                  orderStatusChangeReasonId
                )
                .pipe(
                  catchError((err) => of([response, []])),
                  map((response1) => [response, response1])
                )
            : of([response, []]);
        })
      )
      .subscribe(
        (data) => {
          if (isDisplayNotification) {
            this.showNotification(data[0]);
          }
        },
        (error) => {
          this.showNotification(null);
        }
      );
  }

    showNotification(response : any){
        if (response && response.success){
            let notification: any = this._translatePipe.get('order.Order Notes Created sucessfully');
            this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
            this.getOrderNotes();
            this.getOrderLogs();
        }
        else{
            let notification: any = this._translatePipe.get('order.Order Note creation has been failed');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
    }

    getOrderNotes() {
        if(this.orderInfo && this.orderInfo.webOrderID) {
        this._orderservice.getOrderNotes(this.orderInfo.webOrderID).subscribe(response => {
            if (response) {
                this.orderNotes = response;
                this.orderNotes.forEach((note:any)=> {
                    if (note.createdDate) {
                        note.dateFormat = moment(note.createdDate).utcOffset(this.storeInfo.timeZoneOffset).format('DD-MMM-YYYY');
                        note.hoursFormat = moment(note.createdDate).utcOffset(this.storeInfo.timeZoneOffset).format('HH:mm:ss');
                    }
                });
            }
        });
    }
    }

    getOrderLogs() {
        if(this.orderInfo && this.orderInfo.webOrderID) {
        this._orderservice.getOrderLogs(this.orderInfo.webOrderID).subscribe(response => {
            if (response) {
                this.orderLogs = response;
                if (this.orderLogs && this.orderLogs.length > 0) {
                    this.orderLogs.forEach(x => {
                        if (x.date && this.orderInformation && (this.orderInformation.storePostedOffset || this.orderInformation.storePostedOffset === 0)) {
                            x.dateFormat = moment(x.date).utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY');
                            x.hoursFormat = moment(x.date).utcOffset(this.orderInformation.storePostedOffset).format('HH:mm:ss')
                        }
                    });
                    
                    console.log(this.orderLogs);
                    let index = this.orderLogs.findIndex(x => x.messageTypeId == this.AcknowledgeType);
                    if(index > -1) {
                        this.systemOrderNumberAcknowledgedFromAs400 = true; 
                    }
                }
            }
        });
    }
    }
    /**
     * create order cancel ticket
     */
    createTicket(notes: string, paymentMode: string) {
        this.getTicketTypesAndSubTypes();
        this.getDepartments();
        let ticket = new CreateTicketRequest();
        ticket.sourceId = SourceType.Email;
        ticket.callerName = this.distributorInfo ? this.distributorInfo.name : (this.memberInfo ? this.memberInfo.firstName : this.fboid );
        ticket.operatingCountryId = this.operatingCountry;
        ticket.typeId = this.ticketTypeId ? this.ticketTypeId : Types.Order;
        ticket.subTypeId = SubtypesEnums.Cancel_Order;
        ticket.description = "Order - " + this.orderInformation.webOrderId + " placed using  " + paymentMode + ", cancelled by " + this.userInfo.firstName + " " + this.userInfo.lastName;
        ticket.departmentId = this.departmentId ? (+this.departmentId) : 0;
        ticket.priorityId = Priority.Medium;
        ticket.dueDate = null;
        ticket.subject = "Order - " + this.orderInformation.webOrderId + " cancelled";
        ticket.assignedToId = 0;
        ticket.memberId = (this.distributorInfo && this.distributorInfo.distributorId) ? this.distributorInfo.distributorId : this.fboid;
        ticket.memberType = MemberType.FOB;
        ticket.userId = this.userInfo.userId;
        ticket.firstName = this.userInfo.firstName;
        ticket.lastName = this.userInfo.lastName;
        ticket.sourceIdentifierValue = this.distributorInfo && this.distributorInfo.email ? this.distributorInfo.email : '';
        if (((this.orderInformation.billingInfo.paymentMethod === this.paymentType.Wire_Transfer) || (this.orderInformation.billingInfo.paymentMethod === this.paymentType.Money_order) || (this.orderInformation.billingInfo.paymentMethod === this.paymentType.Orange_Money) || (this.orderInformation.billingInfo.paymentMethod === this.paymentType.eCheck) || (this.orderInformation.billingInfo.paymentMethod === this.paymentType.Ach)) && ((this.orderInformation.orderStatusId === OrderStatusEnums.Accepted) || (this.orderInformation.orderStatusId === OrderStatusEnums.Review_Window))) {
            ticket.statusId = Status.New;
        }
        else {
            ticket.statusId = Status.Closed;
        }
        ticket.orderId = this.orderInformation.webOrderId;
        ticket.note = notes;
        this.saveTicket(ticket);
    }
    saveTicket(saveTicket: CreateTicketRequest) {

        this._customerservice.saveTicket(saveTicket).subscribe(response => {
        });
    }

    getDepartments() {
        this._customerservice.getAllDepartmentsByOperatingCountryId(this.operatingCountry).subscribe(response => {
            if (response && response.length > 0) {
                this.departmentId = response[0].id;
            }
        });
    }
    /**
     * get member information for member type
     */
    getMemberInformation() {
        let type = '';
        let memberDetail = '';
        if (this.orderInformation) {
            memberDetail = this.orderInformation.distrubutorId ? this.orderInformation.distrubutorId :
                this.orderInformation.email;
        }
        type = memberDetail ? memberDetail.indexOf('@') > -1 ? 'email' : 'fboId' : null;
             this._customerservice.getMemberDetails(memberDetail, type).subscribe( (response) => {
            if (response && response.memberId) {
                // this.getMembergovernmentIdentificationsInfo(response.memberId);
                this.isTitanEnabled = response.isSuccess;
                this.memberId = response.memberId;
                this.memberStatus = response.memberStatus;
                       this.maxlimit --;
                this.getMemberLevelInfo(response);
                     //When AS400 is down
                     if (!response.fboId) {
                       this._commonService.getMemberInfoByMemberId(this.orderInformation.memberId).subscribe((res) => {
                             if (res && res[0]) {
                               this.memberInfo.fboId = res[0].code;
                               if (!res[0].code && this.maxlimit === 0 ) {
                                 this.getMemberInformation();
            }
    }
                           }, (error) => {});
                     }
                   }
                 },
               );
    }
    getMemberLevelInfo(memberResponse): void {
      this.processMemberResponse(memberResponse);
      this.getShippingCostWithShippingTax();

        // this._commonService.getMemberLevelDetails(memberResponse.fboId).subscribe((response) => {
        //     if (response && response.memberLevel) {
        //         memberResponse.memberTitle = response.memberLevel;
        //     }
        //     this.processMemberResponse(memberResponse);
        // }, (error) => {
        //     this.processMemberResponse(memberResponse);
        // });
    }

    /**
     * @description
     * @date 2020-09-09
     * @param {*} response
     */
    processMemberResponse(response): void {
        this.memberInfo = response;
        if(this.storeInfo && this.memberInfo){
        this.memberInfo.displayMiddleName = this.storeInfo.displayMiddleName;
        }
        // this.memberInfo.privacyRequested = this._commonService.isPrivacyRequested(response.memberPreferences);
        if (+this.memberInfo.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        const countryObj = this.countries.find((x: any) => x.isocodeThree.toLowerCase()
         === this.orderInformation.countryCode.toLowerCase());
        if (this.memberInfo && countryObj) {
         this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
        }
         this.appConfig = this._appConfigService.getSettings(this.orderInfo.homeCountry, this.memberInfo);
         this.displayOrderVatTax();
        this.memberTypeId = this.memberInfo.memberTypeId;
        if (this.memberInfo && (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST)) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        } else if (+response.memberTypeId === MemberTypeEnum.FPC) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if(this.memberInfo && this.memberInfo.memberTypeId ===MemberTypeEnum.DISTRIBUTOR && this.memberInfo.memberTitleId===MemberLevel.NOVICCUSTOMER){
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }

        this.showCCSnapshot = true;
    }
    displayOrderVatTax(): void {
        if (this.appConfig.enableVATCalculation && this.appConfig.displayVat && this.orderInformation) {
            if (this.orderInformation.orderTypeId === PurchaseFlow.Enrollment && this.orderInformation.initialOrder
                && this.orderInformation.vatRegistered) {
                this.appConfig.displayVat = true;
            } else if (this.shippingAddressInfo && this.shippingAddressInfo.countryId && this.participatingCountries
                && this.participatingCountries.length && this.orderInformation.vatRegistered) {
                const country = this.participatingCountries
                    .find(x => x.countryId === this.shippingAddressInfo.countryId);
                this.appConfig.displayVat = this.getCountryTaxInclusiveInfo(country);
            } else {
                this.appConfig.displayVat = false;
            }
        } else if (this.appConfig.displayVat && !this.appConfig.enableVATCalculation) {
            this.appConfig.displayVat = true;
          } else {
            this.appConfig.displayVat = false;
          }
    }
    getCountryTaxInclusiveInfo(country: any): boolean {
        let countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    }

    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    getImagePath(cardType: any): string {
        let cardTypeImage;
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    cardTypeImage = null;
                    break;
            }
        }
        return cardTypeImage;
    }
    /**
    * create order log request parameter
    */
    createOrderLog(orderLog: string) {
        const orderLogRequest = {
            "messageTypeId": MessageTypeEnum.OrderLogsMessageType,
            "orderId": this.orderInformation.id,
            "webOrderId": this.orderInformation.webOrderId,
            "message": orderLog,
            "source" : Constants.CUSTOMER_SERIVCE
        };
        this._orderservice.createOrderLog(orderLogRequest)
            .subscribe((response) => {
                this.getRecentOrderInformation();
            }, (error: any) => {
                this._commonService.createNotification('', 'Failed to create order log', NotificationType.ERROR);
            });
    }

    getShippingTrackURL(webOrderId: any) {
        //webOrderId ="USA0000001";
        this._orderservice.getShippingTrackingURL(webOrderId).subscribe(response => {
            if (response) {
                this.shipTrackingUrl = response.shipmentTrackingUrl;
            }
        });

    }

    /**
     * Show Order Notes Modal
     */
    openCreateNotesModal() {
        this.buildOrderNotesForm();
        // this._commonService.jumpingScroll(true);
        this.orderNotesModal.open();
    }

    /**
     * Build Form for Order Notes
     */
    buildOrderNotesForm() {
        this.orderNotesForm = this._formbuilder.group({
            ordernotes: ['', [Validators.required]]
        });
    }

    /**
     * close order notes popup
     */
    closeOrderNotesPopup() {
        this.orderNotesModal.close();
        // this._commonService.jumpingScroll(false);
    }

    /**
    * Add Notes
    */
   AddNotes() {
    if (this.orderNotesForm.valid && this.orderNotesForm.value.ordernotes.trim().length > 0) {
        const notes = this.orderNotesForm.value.ordernotes;
        this.orderNotesModal.close();
        // this._commonService.jumpingScroll(false);
        this.createOrderNote(this.orderInfo.webOrderID, notes, true);
       }
   }

   /**
     *
     * @param items
     */
    getItemVolumeSum(items): number {
        if (this.appConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        } else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    }
    trackByItem(index: number): number {
        return index;
    }

    /**
    * edit order
    */
    printOrder() {
        const oldTitle = this.documentRef.title;
        this.documentRef.title = this._translatePipe.get('orderdetails.Forever Living Products')['value'];
        this.showprint = true;
        setTimeout(() => {
            (window as any).print();
            if (window.navigator.userAgent.toLowerCase().indexOf('safari') > -1) {
                setTimeout(() => {
                    this.showprint = false;
                }, 3000);
            }else{
                this.showprint = false;
            }
            this.documentRef.title = oldTitle;
        }, 1000);
    }

    getStoreMetaData(storeId: any) {
        this._commonService.getStoreMetaData(storeId)
            .subscribe(storeMetaData => {
                this.storeMetadata = storeMetaData;
            });
    }

    createNewServiceOrder() {
        if ((!this.isTitanEnabled) || this.memberStatus && (this.memberStatus.id === +MemberStatus.Active)) {
            const CreateOrderInfo = {
                distributorId: this.fboid,
                webOrderId : this.orderInfo.webOrderID,
                countryId: this.orderInformation.countryCode
            };
            this._cacheService.set(CacheKey.CREATE_SERVICE_ORDER_INFO_SESSION_CODE, CreateOrderInfo);
            this._cacheService.set(CacheKey.IsServiceOrder, true);
        } else {
            this.memberRestrictions.open();
            return false;
        }
    }

    closeRestrictionPopup = () => {
        this.memberRestrictions.close();
    }

    /**
     * Get State Info by stateCode and countryCode
     * @param stateCode
     * @param countryCode
     *
     */
    private getStateByStateCodeAndCountryCode(stateCode: string,countryCode:string): string {
        let stateName = "";
        if (stateCode && countryCode ) {
            let stateObj = this.states.find((x: any) => x.stateCode === stateCode && x.countryCode===countryCode);
            stateName = stateObj ? stateObj.stateName : '';
            this.orderInformation.billingInfo.dlState = stateName;
        }
        return stateName;
    }

    fetchEcheckSecTypes(secType: string): string{
        if(secType === SecType.Web){
          return 'WEB ACH'
        }else{
            return 'PPD ACH'
        }
    }

    onCancelOptionChange(value: string) : void {
        this.isCancelAlone = value && value.toLowerCase() === cancelOrderOptions.CANCEL.toLowerCase() ? true : false;
    }

    changeDistributorIdForAnExistingOrder(){
        this.isMemberSearchSucess = false;
        this.FboIDSearchForm = this._formbuilder.group({
            distributorID:['',Validators.required]
        });
        this.onValueChanges();
        this.updateFboIdOfAnOrderModal.open();
    }

    closeupdateFboIdOfAnOrderModalPopup(isReset?:boolean):void{
        if(isReset){
            this.distributorIDofValenceSearch = '';
            this.isMemberSearchSucess = false;
            this.FPCOrFBONotFoundErrorMessage = false;
            this.errorMessage = false;
            this.distributorDetailsForValenceSearch =null;
            this.isNotAuthorizedCountry =false;
        }
        this.updateFboIdOfAnOrderModal.close();
    }

    onSubmitFboSearchForm(isValidForm: boolean) {
        if (isValidForm) {
            this.distributorIDofValenceSearch = this.FboIDSearchForm.get('distributorID').value;
            if (!this.isMemberSearchSucess) {
                this.distributorDetailsForValenceSearch = null;
                this.isMemberSearchSucess = false;
                this.FPCOrFBONotFoundErrorMessage = false;
                this.errorMessage = false;
                this.isNotAuthorizedCountry = false;
                this.notAuthorizedCountryMessage = '';
                const searchRequest: SearchRequest = this.prepareMemberSearchForFboIdChange(this.distributorIDofValenceSearch);
                this._commonService.getFBOSearchResults(searchRequest)
                    .pipe(
                        switchMap(
                            (memberSearchResponse: MemberSearchByFboIdResponse) => memberSearchResponse && memberSearchResponse.success && memberSearchResponse.fboSearchResultModelList && !memberSearchResponse.validations ? this._commonService.getMemberAllowedCountries(memberSearchResponse.fboSearchResultModelList[0].id)
                                .pipe(
                                    map((memberAllowedCountries: MemberAllowedCountries[]) => ({ memberSearchResponse, memberAllowedCountries }))
                                ) : of({ memberSearchResponse, memberAllowedCountries: [] })
                        )
                    )
                    .subscribe(response => {
                        if (response.memberSearchResponse && response.memberAllowedCountries && response.memberAllowedCountries.length > 0 && response.memberSearchResponse.success && response.memberSearchResponse.recordsCount > 0 && response.memberSearchResponse.fboSearchResultModelList && !response.memberSearchResponse.validations) {
                            const isAuthorizedCountry: any = response.memberAllowedCountries.filter(country => country.isoCodeThree === this.orderInformation.countryCode);
                            if (isAuthorizedCountry && isAuthorizedCountry.length > 0) {
                                this.distributorDetailsForValenceSearch = response.memberSearchResponse.fboSearchResultModelList[0];
                                this.isMemberSearchSucess = true;
                            }
                            else {
                                this.isNotAuthorizedCountry = true;
                                const errMsg: any = this._translatePipe.get('validation-message.Entered DistributorID is not authorized to place order in {{store}}. Please try again.', { store: this.orderInformation && this.orderInformation.countryCode ? this.orderInformation.countryCode : null });
                                this.notAuthorizedCountryMessage = errMsg.value;
                            }
                        }
                        else if (response.memberSearchResponse && response.memberSearchResponse.validations && response.memberSearchResponse.validations.length > 0 && response.memberAllowedCountries.length === 0) {
                            if ((response.memberSearchResponse.validations[0].name.toLocaleLowerCase() === "completed") && (response.memberSearchResponse.validations[0].message.toLocaleLowerCase() === Constants.NOT_FPC_OR_FBO_CUSTOMER.toLocaleLowerCase()||response.memberSearchResponse.validations[0].message.toLocaleLowerCase() === Constants.NOT_ACTIVE.toLocaleLowerCase())) {
                                this.FPCOrFBONotFoundErrorMessage = true;
                            }
                            else if (response.memberSearchResponse.validations[0].name.toLocaleLowerCase() === "not exist" && response.memberSearchResponse.validations[0].message.toLocaleLowerCase() === Constants.NOT_EXIST_MSG.toLocaleLowerCase()) {
                                this.errorMessage = true;
                            }
                        }
                    }, (error: any) => {
                        this.closeupdateFboIdOfAnOrderModalPopup(true);
                        this.toasterMsg('common.Sorry error occurred while fetching member details.', NotificationType.ERROR);
                    });
            }
        }
    }

    prepareMemberSearchForFboIdChange(distributorID:string):SearchRequest{
        if(distributorID){
            const searchRequest: SearchRequest = {
                pageNumber: 1,
                pageSize: 10,
                sort: 'DESC',
                isAdvancedSearch: false,
                searchBy: 'MEMBER',
                sortOrder: ['fboId'],
                searchCriteria: [
                    {
                        searchKey: 'FBOID',
                        searchValue: distributorID
                    }
                ],
                valenceSearch: true
            };
            return searchRequest;
        }
        return null;
    }

    confirmationModalForUpdatingFboIdOfAnOrder():void{
        this.closeupdateFboIdOfAnOrderModalPopup();
        this.distributorIDofValenceSearch='';
        this.isConfirmationModalMessage = true;
        this.confirmOrSuccessFboIdOfAnOrderModal.open();
    }

    onValueChanges():void{
        this.formSubscription = this.FboIDSearchForm.get('distributorID').valueChanges
        .pipe(debounceTime(1000))
        .subscribe((res) =>{
            if(this.distributorIDofValenceSearch !=''){
                if(res === this.distributorIDofValenceSearch){
                    this.isMemberSearchSucess = true;
                }
                else{
                    this.isMemberSearchSucess = false;
                    this.FPCOrFBONotFoundErrorMessage = false;
                    this.errorMessage = false;
                    this.isNotAuthorizedCountry= false;
                }
            }
        });
    }

    getBonusRunStatusDetails(type?:String):void{
        this.bonusDetails = null;
        const todayDate = new Date(this.orderInformation.orderPostedDate).getDate();
        let currentMonth = this.orderInformation.processedMonth;
        let currentYear = this.orderInformation.processedYear;
        if((currentMonth != null && currentMonth != 0) && (currentYear != null && currentYear !=0)){
            this._customerservice.getBonusRunStatusDetails(this.storeInfo.operatingCountry,currentMonth,currentYear).subscribe((res)=>{
                if(res && res.success && res.validations.length===0){
                    this.bonusDetails = res;
                    if (type) {
                        if (type.toLowerCase() === Constants.CANCEL_ORDER.toLowerCase()) {
                            this.openCancelOrderPopup();
                        }
                        if (type.toLowerCase() === Constants.UPDATE_FBOID_OF_ORDER.toLowerCase()) {
                            this.checkBonusStatusAndOrderStatus(res);
                        }
                        if (type == Constants.PROCESSING_PERIOD) {
                            this.populateBonusStatuses();
                        }
                    }
                }
                else if (res && res.validations && res.validations.length>0){
                    this.toasterMsg('common.Sorry error occurred while fetching bonus run status for selected period.',NotificationType.ERROR);
                }
            },(err:any)=>{
                this.distributorIDofValenceSearch = '';
                this.toasterMsg('common.Sorry error occurred while fetching bonus run status for selected period.',NotificationType.ERROR);
            })
        }else{

            // this.orderInformation.webOrderId
            let message : string = null;
            if (type.toLowerCase() === Constants.CANCEL_ORDER.toLowerCase()) {
                message = 'validation-message.Sorry, the order {{webOrderId}} that you are trying to cancel is not qualified for cancelation due to following reasons';
            }
            if (type.toLowerCase() === Constants.UPDATE_FBOID_OF_ORDER.toLowerCase()) {
                message ='validation-message.Sorry, the distributorId update on order {{webOrderId}} that you are trying to change is not possible currently, due to following reasons';
            }
            message = message + ' <ul><li>Payment not completed</li></ul>';
            this.toasterMsg(message,NotificationType.ERROR,true);
        }

    }

    confirmUpdateFboIdForExistingOrder():void{
        this.isConfirmationModalMessage = false;
        this.closeconfirmationOrSucessModalForUpdatingFboIdOfAnOrder(false,false);
        this._orderservice.updateDistributorIdForExistingOrder(this.orderInformation.id,this.orderInformation.webOrderId,this.distributorDetailsForValenceSearch.fboId,this.userInfo.userId,this.storeInfo.operatingCountry)
        .subscribe((res:any)=>{
            if(res && res.validations && res.success){
                this.isDistributorIdChangedSuccessMessage = true;
                this.confirmOrSuccessFboIdOfAnOrderModal.open();
            }
            else if(res && res.validations && res.validations.length>0){
                this.toasterMsg('common.Sorry error occurred while updating FBOID of the order.',NotificationType.ERROR);
            }
        },(err)=>{
            this.toasterMsg('common.Sorry error occurred while updating FBOID of the order.',NotificationType.ERROR);
        });
        this.isMemberSearchSucess = false;
        this.FPCOrFBONotFoundErrorMessage = false;
        this.errorMessage = false;
        this.isNotAuthorizedCountry = false;
    }

    closeconfirmationOrSucessModalForUpdatingFboIdOfAnOrder(isConfirmationPopUp?:boolean,isSuccessPopUp?:boolean):void{
        if(isSuccessPopUp) {
            this.isDistributorIdChangedSuccessMessage = false;
            this.distributorDetailsForValenceSearch=null;
            this.closeTabForParticularDistributor.emit(this.orderInfo.distributorID);
        }
        if(isConfirmationPopUp){
            this.isConfirmationModalMessage = false;
            this.isMemberSearchSucess = this.isConfirmationModalMessage;
            this.distributorDetailsForValenceSearch = null;
        }
        this.distributorIDofValenceSearch = '';
        this.confirmOrSuccessFboIdOfAnOrderModal.close();
    }


    editProcessingPeriod() {
        this.bonusStatuses = [];
        this.selectedBonusPeriod = null;
        this.submitProcessOrder = false;
        if (!this.hasCommissionActvityPermission
            && !(this.orderInformation && this.orderInformation.processedMonth && this.orderInformation.processedYear)) return;
        let currentDate = new Date();
        const processingPeriod = new Date(this.orderInformation.processedYear, this.orderInformation.processedMonth - 1, 1);
        const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
        if (processingPeriod >= nextMonth) {
            this.toasterMsg('common.Sorry Bonus Status is not available for the order processing period', NotificationType.ERROR);
            return;
        }
        this.getBonusRunStatusDetails(Constants.PROCESSING_PERIOD);
    }

    populateBonusStatuses(){
        if (this.bonusDetails && this.bonusDetails.success && (this.bonusDetails.bonusStatusId == BonusStatus.OPEN || this.bonusDetails.bonusStatusId == BonusStatus.RESTRICTED)) {
            let reqObj = this.prepareRequestObjForBonusStatus();
            if (reqObj && !!reqObj.length) {
                let modifyReqObj = reqObj.filter(x => this.orderInformation.processedMonth != x.month );
                this.processingPeriodModal.open();
                let reqs = [];
                for (let i = 0; i < modifyReqObj.length; i++) {
                    reqs.push(this._customerservice.getBonusRunStatusDetails(modifyReqObj[i].opCo, modifyReqObj[i].month, modifyReqObj[i].year).pipe(catchError((err: any) => {
                        return of({ isError: true, error: err })
                    })))
                }
                forkJoin(reqs).pipe(
                takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
                    this.bonusStatuses = [];
                    if (res && !!res.length) {
                        res.splice(1,0,{...this.bonusDetails});
                        res.forEach((bonusResponses, i) => {
                            const statuses = this.setBonusStatus(bonusResponses);
                            this.bonusStatuses.push({
                                status: statuses,
                                month: Months[reqObj[i].month],
                                processedMonth: reqObj[i].month,
                                year: reqObj[i].year,
                                disabled: statuses &&  this.checkStatus(statuses) ? false : true
                            });
                        });
                        let futureProcessingPeriod = !!this.bonusStatuses.length && this.bonusStatuses[this.bonusStatuses.length-1] ;
                        if(futureProcessingPeriod && futureProcessingPeriod.status && futureProcessingPeriod.status.toLowerCase() == Constants.BONUS_STATUS_NOT_AVAILABLE){
                            futureProcessingPeriod.disabled = false;
                        }
                        const currentBonusPeriod = !!this.bonusStatuses.length && this.bonusStatuses.find(bonusPeriod => bonusPeriod.processedMonth == this.orderInformation.processedMonth);
                        this.selectedBonusPeriod = currentBonusPeriod && !!Object.keys(currentBonusPeriod).length ? currentBonusPeriod : {};

                    } else {
                        this.selectedBonusPeriod = {}
                        this.toasterMsg('common.Sorry error occurred while fetching bonus run status',NotificationType.ERROR);
                    }
                },
                    err => {
                        this.selectedBonusPeriod={};
                        this.toasterMsg('common.Sorry error occurred while fetching bonus run status',NotificationType.ERROR);
                    }
                )
            }
        } else {
            this.toasterMsg('common.Bonus Statuses is not Open or Restricted',NotificationType.ERROR);
        }
    }

    prepareRequestObjForBonusStatus() {
        let reqObj = [];
        const processingMonth = this.orderInformation.processedMonth;
        const processingYear = this.orderInformation.processedYear;
        const processingPeriod = new Date(processingYear, processingMonth - 1, 1);
        const pastProcessingPeriod = new Date(processingPeriod.getFullYear(), processingPeriod.getMonth() - 1);
        const futureProcessingPeriod = new Date(processingPeriod.getFullYear(), processingPeriod.getMonth() + 1);
        reqObj = [
            { opCo: this.storeInfo.operatingCountry, month: pastProcessingPeriod.getMonth() + 1, year: pastProcessingPeriod.getFullYear(), },
            { opCo: this.storeInfo.operatingCountry, month: processingPeriod.getMonth() + 1, year: processingPeriod.getFullYear() },
            { opCo: this.storeInfo.operatingCountry, month: futureProcessingPeriod.getMonth() + 1, year: futureProcessingPeriod.getFullYear() }
        ];
        return reqObj;
    }

    setBonusStatus(bonusResponses) {
        let Status = Constants.ERROR_OCCURED_FETCHING_BONUS_STATUS;
        if (bonusResponses && !!Object.keys(bonusResponses).length) {
            if (bonusResponses.success) return bonusResponses.bonusStatus;
            if (!bonusResponses.success && bonusResponses.validations && !!bonusResponses.validations.length) {
                for (let i = 0; i < bonusResponses.validations.length; i++) {
                    if (bonusResponses.validations[i].message && bonusResponses.validations[i].message.toLowerCase()
                        && (bonusResponses.validations[i].message.toLowerCase().indexOf(Constants.NOT_AVAILABLE) > -1)) {
                        Status = Constants.BONUS_STATUS_NOT_AVAILABLE;
                        break;
                    }
                }
            }
        }
        return Status;
    }

    toasterMsg(msg: string, type: string , isProcessingPeriodNotAvailable? :boolean) {
        let errorMessage: any
        if(isProcessingPeriodNotAvailable != null && isProcessingPeriodNotAvailable){
            errorMessage = this._translatePipe.get(msg,{webOrderId:this.orderInformation && this.orderInformation.webOrderId? this.orderInformation.webOrderId:null});
        }else{
            errorMessage = this._translatePipe.get(msg);
        }

        this._commonService.createNotification('', errorMessage.value, type);
    }

    isProcessingPeriodHasAccess() {
        if (this.bonusStatuses && !!this.bonusStatuses.length && this.selectedBonusPeriod && this.orderInformation && this.orderInformation.processedMonth) {
            this.selectedBonusPeriod.error = false;
            this.selectedBonusPeriod.errMsg = " ";
            if(this.orderInformation.processedMonth == this.selectedBonusPeriod.processedMonth) return false;
            if (this.selectedBonusPeriod.disabled) {
                this.selectedBonusPeriod.error = true;
                this.selectedBonusPeriod.errMsg = this.selectedBonusPeriod.month +' '+ Constants.NOT_OPEN_OR_RESTRICTED_STATUSES;
                return false;
            }
            return true;
        }
        return false;
    }

    isBonusStatusOpenOrRestricted(period) {
        const getStatus = this.bonusStatuses.find(status => (status.processedMonth == period));
        return getStatus && getStatus.status && this.checkStatus(getStatus.status);
    }

    checkStatus(status) {
        if (status && (status.toLowerCase() == BonusConstants.Open.toLowerCase() ||
            status.toLowerCase() == BonusConstants.Restricted.toLowerCase())) {
            return true;
        }
        return false;
    }

    submitProcessingPeriod() {
        if (this.isProcessingPeriodHasAccess()) {
            this.submitProcessOrder = true;
        }
    }

    confirmProcessingPeriod() {
        if (this.submitProcessOrder && this.orderInfo && this.orderInfo.webOrderID && this.orderInfo.homeCountry && this.orderInformation) {
            this.processingPeriodModal.close();
            this._orderservice.updateProcessingPeriodForOrder(this.orderInfo.webOrderID, this.orderInfo.homeCountry, this.selectedBonusPeriod.year, this.selectedBonusPeriod.processedMonth,this.userInfo.userId,this.orderInformation.id).subscribe(res => {
                if (res && res.success) {
                    this.getRecentOrderInformation();
                    this.toasterMsg('common.Order Processing Period updated successfully', NotificationType.SUCCESS);
                } else {
                    this.toasterMsg('common.Sorry error occurred while updating processing period of the order', NotificationType.ERROR);
                }
            }, err => {
                this.toasterMsg('common.Sorry error occurred while updating processing period of the order', NotificationType.ERROR);
            })
        }
    }

    closeProcessingPeriod() {
        if (this.submitProcessOrder) {
            this.submitProcessOrder = !this.submitProcessOrder;
            return;
        }
        this.processingPeriodModal.close();
    }

    checkBonusStatusAndOrderStatus(res:any):void{
        if((res.bonusStatus.toLocaleLowerCase() === Constants.BONUS_RUN_STATUS_OPEN.toLocaleLowerCase() || res.bonusStatus.toLocaleLowerCase() === Constants.BONUS_RUN_STATUS_RESTRICTED.toLocaleLowerCase())){
           if(!(this.orderInformation.orderStatusId === OrderStatusEnums.Cancelled || this.orderInformation.orderStatusId === OrderStatusEnums.Failed))    this.changeDistributorIdForAnExistingOrder();
           else this.toasterMsg('common.Sorry You are unable to update FBOID of the order because its status is failed or cancelled.',NotificationType.ERROR);
        }
        else this.toasterMsg("common.The bonus run status for this order's processing period is not open or restricted.",NotificationType.ERROR);
    }

/*    getMembergovernmentIdentificationsInfo(memberId: number) {
        if(memberId){
            this._customerservice.getMembergovernment_identifications(memberId).subscribe(response =>{
                if(response && response.memberGovernmentIdentificationModel){
                  this.memberGovernmentIdentifiations = response.memberGovernmentIdentificationModel;
                }
                this.getShippingCostWithShippingTax(); 
            });
        }
    } 

    getVatIdfromMember() {
        const countries = this._cacheService.get(CacheKey.COUNTRIES);
        const orderCountryId = countries.find((y: Country) => y.isocodeThree.toUpperCase() === this.orderInformation.countryCode.toUpperCase()).countryId;        
        if(this.memberGovernmentIdentifiations){                      
            const memberGovernmentIdentifiation = this.memberGovernmentIdentifiations.find(x => (x.governmentIdentificationType).toUpperCase() === GovernmentIdentificationType.VAT_ID && x.countryID === orderCountryId);
            this.memberInfo.vatRegistered = memberGovernmentIdentifiation ? true : false;
        }           
    } */
    
    ngOnDestroy(){
        this.formSubscription && this.formSubscription.unsubscribe();
        if (this.ngUnsubscribe) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
          }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/recent-order-view.component.ts